import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    "Sr No.",
    "Source Name",
    "Lead Group",
    "Status",
    "Actions"
  ];
  
  export const TABLE_DATA = [
    { id: 1, sourcename: "John Doe", leadgroup: "Retail", status: "Active", actions: "Edit/Delete" },
    { id: 2, sourcename: "Jane Smith", leadgroup: "Wholesale",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, sourcename: "Michael Johnson", leadgroup: "Retail",  status: "Active", actions: "Edit/Delete" },
    { id: 4, sourcename: "John Doe", leadgroup: "Retail", status: "Active", actions: "Edit/Delete" },
    { id: 5, sourcename: "Jane Smith", leadgroup: "Wholesale",  status: "Inactive", actions: "Edit/Delete" },
    { id: 6, sourcename: "Michael Johnson", leadgroup: "Retail",  status: "Active", actions: "Edit/Delete" },
    { id: 7, sourcename: "John Doe", leadgroup: "Retail", status: "Active", actions: "Edit/Delete" },
    { id: 8, sourcename: "Jane Smith", leadgroup: "Wholesale",  status: "Inactive", actions: "Edit/Delete" },
    { id: 9, sourcename: "Michael Johnson", leadgroup: "Retail",  status: "Active", actions: "Edit/Delete" },
    { id: 10, sourcename: "John Doe", leadgroup: "Retail", status: "Active", actions: "Edit/Delete" },
    { id: 11, sourcename: "Jane Smith", leadgroup: "Wholesale",  status: "Inactive", actions: "Edit/Delete" },
    { id: 12, sourcename: "Michael Johnson", leadgroup: "Retail",  status: "Active", actions: "Edit/Delete" },
    { id: 13, sourcename: "John Doe", leadgroup: "Retail", status: "Active", actions: "Edit/Delete" },
    { id: 14, sourcename: "Jane Smith", leadgroup: "Wholesale",  status: "Inactive", actions: "Edit/Delete" },
    { id: 15, sourcename: "Michael Johnson", leadgroup: "Retail",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    "Sr No.": "id",
    "Source Name": "sourcename",
    "Lead Group": "leadgroup",
    
    "Status": "status",
    "Actions": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };